import {RestApiService} from '../../../rest-api.service';
import {Observable} from "rxjs";
import {FileUploadRes} from '@yasc/yasc-material-components';
import {EntityMappingTableDataResponse} from '../../../../contracts/v0/entity-mapping/entity.mapping.table.data.contracts';
import {ApiV0} from '../../api.v0';

export class ApiV0EntityMapping {
    segment: string;

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + '/entityMapping';
    }

    // functions for handling json data
    importFromJsonData(fileUploadRes: FileUploadRes): Observable<EntityMappingTableDataResponse> {
        return this.rest.post<{}, EntityMappingTableDataResponse>(`${this.segment}/import/json/${fileUploadRes.id}`, EntityMappingTableDataResponse);
    }

    // exportToJsonData(guidList: string[]): Observable<EntityMappingTableDataResponse> {
    //     return this.rest.post<string[], EntityMappingTableDataResponse>(`${this.segment}/export/json`, guidList);
    // }

    // functions for handling xml data
    importFromXmlData(fileUploadRes: FileUploadRes): Observable<EntityMappingTableDataResponse> {
        return this.rest.post<{}, EntityMappingTableDataResponse>(`${this.segment}/import/xml/${fileUploadRes.id}`, EntityMappingTableDataResponse);
    }

    // exportToXmlData(guidList: string[]): Observable<EntityMappingTableDataResponse> {
    //     return this.rest.post<string[], EntityMappingTableDataResponse>(`${this.segment}/export/xml`, guidList);
    // }

    // functions for handling csv files
    importFromCsvData(fileUploadRes: FileUploadRes): Observable<EntityMappingTableDataResponse> {
        return this.rest.post<{}, EntityMappingTableDataResponse>(`${this.segment}/import/csv/${fileUploadRes.id}`, EntityMappingTableDataResponse);
    }

    // exportToCsvData(guidList: string[]): Observable<EntityMappingTableDataResponse> {
    //     return this.rest.post<string[], EntityMappingTableDataResponse>(`${this.segment}/export/csv`, guidList);
    // }

    // functions for handling excel data
    importFromExcelData(fileUploadRes: FileUploadRes): Observable<EntityMappingTableDataResponse> {
        return this.rest.post<{}, EntityMappingTableDataResponse>(`${this.segment}/import/excel/${fileUploadRes.id}`, EntityMappingTableDataResponse);
    }

    // exportToExcelData(guidList: string[]): Observable<EntityMappingTableDataResponse> {
    //     return this.rest.post<string[], EntityMappingTableDataResponse>(`${this.segment}/export/excel`, guidList);
    // }

    // functions for handling word data
    importFromWordData(fileUploadRes: FileUploadRes): Observable<EntityMappingTableDataResponse> {
        return this.rest.post<{}, EntityMappingTableDataResponse>(`${this.segment}/import/word/${fileUploadRes.id}`, EntityMappingTableDataResponse);
    }

    // exportToWordData(guidList: string[]): Observable<EntityMappingTableDataResponse> {
    //     return this.rest.post<string[], EntityMappingTableDataResponse>(`${this.segment}/export/word`, guidList);
    // }

}
